"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateTable = exports.useCreateTable = exports.useFetchTable = void 0;
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const tableAction_1 = require("./tableAction");
const useFetchTable = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const tableFetchLoading = (0, react_redux_1.useSelector)((state) => state['table/fetch'].loading);
    const tableFetchError = (0, react_redux_1.useSelector)((state) => state['table/fetch'].error);
    const tableFetchData = (0, react_redux_1.useSelector)((state) => state['table/fetch'].data);
    const fetchTable = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let userLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
        if (!userLoggedIn) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, tableAction_1.fetch)(payload));
    });
    return {
        tableFetchLoading,
        tableFetchError,
        tableFetchData,
        fetchTable
    };
};
exports.useFetchTable = useFetchTable;
const useCreateTable = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const tableCreateLoading = (0, react_redux_1.useSelector)((state) => state['table/create'].loading);
    const tableCreateError = (0, react_redux_1.useSelector)((state) => state['table/create'].error);
    const tableCreateData = (0, react_redux_1.useSelector)((state) => state['table/create'].data);
    const createTable = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLoggedIn) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, tableAction_1.create)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, 'Table created successfully');
            }
            else if (res.meta.requestStatus === 'rejected') {
                onComplete(false, true, res.error.message);
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        tableCreateLoading,
        tableCreateError,
        tableCreateData,
        createTable
    };
};
exports.useCreateTable = useCreateTable;
const useUpdateTable = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useNavigate)();
    const tableUpdateLoading = (0, react_redux_1.useSelector)((state) => state['table/update'].loading);
    const tableUpdateError = (0, react_redux_1.useSelector)((state) => state['table/update'].error);
    const tableUpdateData = (0, react_redux_1.useSelector)((state) => state['table/update'].data);
    const updateTable = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLoggedIn = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLoggedIn) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, tableAction_1.update)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, 'Table updated successfully');
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error("Error in updating table");
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        tableUpdateLoading,
        tableUpdateError,
        tableUpdateData,
        updateTable
    };
};
exports.useUpdateTable = useUpdateTable;
